export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-400">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <span className="text-xl font-bold text-white">Ctrl+Z</span>
            <p className="mt-4 text-sm text-primary-300 max-w-md">
              Time-boxed backups for Git repositories. Runs in your CI, stores in SnapBucket, auto-expires after 1, 7, 30 days or as configured.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/docs" className="hover:text-white transition-colors">Documentation</a>
              </li>
              <li>
                <a href="/swagger" className="hover:text-white transition-colors">API Reference</a>
              </li>
              <li>
                <a
                  href="https://gitlab.com/mallocrun/ctrlz"
                  className="hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Source Code
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Related</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://snap.malloc.run"
                  className="hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SnapBucket
                </a>
              </li>
              <li>
                <a
                  href="https://malloc.run"
                  className="hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Malloc.run
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-primary-500">
            &copy; 2025 CtrlZ by KatSkill | All Rights Reserved
          </p>
          <a
            href="mailto:contact@katskill.dev"
            className="text-sm text-primary-400 hover:text-white transition-colors"
          >
            Contact Us
          </a>
        </div>
      </div>
    </footer>
  )
}
